import React from "react"
import { FormattedMessage } from "react-intl"
import { period } from "../../utils"

const SubTitleValueShareModel: React.FC<{
	time: string
	metric: string
	quantity: number
}> = ({ time, metric, quantity }) => (
	<div className="subtitle">
		<FormattedMessage
			id="phronesis.transactional.application.commercial.benchmark.breakdown.subTitle"
			values={{
				metric,
				quantity,
				time: period[time],
				b: (t: any) => <b>{t}</b>,
			}}
		/>
	</div>
)

export default SubTitleValueShareModel
